module.exports = __webpack_public_path__ + "img/punta-del-este.5ba16cc2.jpg";